/* src/app/views/template/components/edit-template-menu-section/edit-template-menu-section-header/edit-template-menu-section-header.component.scss */
.section-template-secondary-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f2f2f2;
}
.section-template-left-side-of-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;
}
.section-template-right-side-of-header {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  align-items: flex-start;
  align-self: flex-end;
}
/*# sourceMappingURL=edit-template-menu-section-header.component.css.map */
